<div *ngFor="let item of items">
    <ng-container *ngIf="!item.hide">
        <input type="checkbox" [checked]="item.isChecked" [disabled]="item.disabled"
            (change)="onCheckboxChange($event, item)">
        <label style="margin-left: 5px;">{{ item[labelProperty] }}</label>
    </ng-container>
</div>
<div *ngIf="control.invalid && (submitted || control.touched)"
    style="font-size: .875rem; color: #dc3545;position: absolute;">
    <div *ngIf="control.errors?.['required']">{{ errorMessage }}</div>
</div>